import React from "react";
import plus from "../plus.svg";

interface IProps {
  onClick: () => void;
}

interface IState {
  func: () => void;
}

export class PlusBTN extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { func: props.onClick };
  }
  render(): React.ReactNode {
    return (
      <img
        src={plus}
        alt=""
        height="36px"
        onClick={this.state.func}
        style={{ userSelect: "none" }}
      />
    );
  }
}
